import { api } from './api';
import { endpoints } from './endpoints';

export const getConfigs = () => api.get(endpoints.getConfigs()).then(res => res.data);

export const getIconSet = () => api.get(endpoints.getIconSet()).then(res => res.data);

export const getSelection = () => api.get(endpoints.getSelection()).then(res => res.data);

export const getTheme = () => api.get(endpoints.getTheme()).then(res => res.data);
